//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { image } from "@/utils/Tool";
import { getAction } from "@api/manage";
import CptImage from "@/components/element/cpt-image";
import CptDataVBorder from "@/components/dataV/cpt-dataV-border";
import CptButton from "@/components/element/cpt-button";
import CptText from "@/components/element/cpt-text";
import CptCarousel from "@/components/element/cpt-carousel";
import CptDataVDecoration from "@/components/dataV/cpt-dataV-decoration";
import CptDataVDigitalFlop from "@/components/dataV/cpt-dataV-digitalFlop";
import CptDataVPercentPond from "@/components/dataV/cpt-dataV-percentPond";
import CptNum from "@/components/element/cpt-num";
import CptRectNum from "@/components/element/cpt-rect-num";
import CptChartClock from "@/components/echarts/cpt-chart-clock";
import CptChartColumn from "@/components/echarts/cpt-chart-column";
import CptChartGauge from "@/components/echarts/cpt-chart-gauge";
import CptChartMapGc from "@/components/echarts/cpt-chart-map-gc";
import CptChartMapMigrate from "@/components/echarts/cpt-chart-map-migrate";
import CptIframe from "@/components/element/cpt-iframe";
import CptChartTdColumn from "@/components/echarts/cpt-chart-td-column";
import CptChartPie from "@/components/echarts/cpt-chart-pie";
import CptDataVScrollTable from "@/components/dataV/cpt-dataV-scrollTable";
import CptDataVScrollList from "@/components/dataV/cpt-dataV-scrollList";
import CptDataVWaterLevel from "@/components/dataV/cpt-dataV-waterLevel";
import CptChartLine from "@/components/echarts/cpt-chart-line";
import CptDataVActiveRing from "@/components/dataV/cpt-dataV-activeRing";
import CptScrollTable from "@/components/element/cpt-scroll-table";
export default {
  name: "preview_index",
  components: {
    CptScrollTable: CptScrollTable,
    CptDataVActiveRing: CptDataVActiveRing,
    CptChartLine: CptChartLine,
    CptDataVWaterLevel: CptDataVWaterLevel,
    CptDataVScrollList: CptDataVScrollList,
    CptDataVScrollTable: CptDataVScrollTable,
    CptChartPie: CptChartPie,
    CptChartTdColumn: CptChartTdColumn,
    CptIframe: CptIframe,
    CptChartMapMigrate: CptChartMapMigrate,
    CptChartMapGc: CptChartMapGc,
    CptChartGauge: CptChartGauge,
    CptChartColumn: CptChartColumn,
    CptChartClock: CptChartClock,
    CptRectNum: CptRectNum,
    CptNum: CptNum,
    CptDataVPercentPond: CptDataVPercentPond,
    CptDataVDigitalFlop: CptDataVDigitalFlop,
    CptDataVDecoration: CptDataVDecoration,
    CptCarousel: CptCarousel,
    CptText: CptText,
    CptButton: CptButton,
    CptDataVBorder: CptDataVBorder,
    CptImage: CptImage
  },
  provide: function provide() {
    return {
      queryParam: this.param
    };
  },
  data: function data() {
    return {
      param: {},
      designCache: {},
      windowWidth: 0,
      windowHeight: 0,
      conHeight: 0,
      containerScale: 1,
      authCodeDialogVisible: false,
      viewCode: '',
      url: {
        loadDesign: '/base/dataScreen/view'
      }
    };
  },
  mounted: function mounted() {
    var that = this;
    that.loadCacheData();

    window.onresize = function () {
      return function () {
        that.loadSize();
      }();
    };
  },
  methods: {
    image: image,
    loadCacheData: function loadCacheData() {
      var that = this;
      var id = this.$route.params.id;

      if (!id) {
        this.$message.error('id错');
        return;
      }

      getAction(this.url.loadDesign, {
        id: id
      }).then(function (res) {
        if (res.success) {
          that.param.orderNoticeId = res.result.paramOrderNoticeId ? res.result.paramOrderNoticeId : '';
          that.param.organizationId = res.result.paramOrganizationId ? res.result.paramOrganizationId : '';
          that.loadDesign(res.result.reportDesign);
        }
      });
    },
    loadDesign: function loadDesign(designStr) {
      var design = JSON.parse(designStr);
      document.title = design.title;
      this.designCache = design;
      this.loadSize();
    },
    loadSize: function loadSize() {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowHeight = document.documentElement.clientHeight;
      this.containerScale = Math.round(this.windowWidth / this.designCache.scaleX * 100) / 100;
      this.conHeight = this.designCache.scaleY;
      console.log(this.windowWidth, this.containerScale);
    }
  }
};